import colorPalette from "../content/styles/scss/_palette.module.scss";
import { useTranslation } from "react-i18next";

export const useFilingStatus = () => {
  const { t } = useTranslation(["Shared"]);

  var filingStatus = [
    {
      Id: 1,
      Title: t("FillingStatus.Filed"),
      Color: colorPalette.experttaxLightGreen1,
    },
    {
      Id: 2,
      Title: t("FillingStatus.NotFiled"),
      Color: colorPalette.experttaxLightGray,
    },
    {
      Id: 3,
      Title: t("FillingStatus.WaitingResponse"),
      Color: colorPalette.experttaxLightBlue0,
    },
    {
      Id: 4,
      Title: t("FillingStatus.Error"),
      Color: colorPalette.experttaxLightRed1,
    },
  ];

  return { data: filingStatus, isPending: false };
};
